import React from 'react';
import PropTypes from 'prop-types';

const SectionHeader = ({
  title,
  description,
  className = '',
  titleClassName = '',
  descriptionClassName = '',
  centered = false,
}) => {
  const containerClasses = `flex flex-col items-${centered ? 'center' : 'start'} gap-2.5 ${className}`;
  const titleClasses = `text-2xl md:text-[32px] leading-[36px] md:leading-[52px] font-semibold text-deep-blue-70 ${titleClassName}`;
  const descriptionClasses = `text-base leading-6 font-normal font-mark-ot text-gray-90 max-w-4xl mt-4 ${descriptionClassName}`;

  return (
    <div className={containerClasses}>
      <h2 className={titleClasses}>{title}</h2>
      {description && <p className={descriptionClasses}>{description}</p>}
    </div>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  centered: PropTypes.bool,
};

export default SectionHeader;
